import React from 'react';
import Icon from '@ant-design/icons';

type IconProps = React.ComponentProps<typeof Icon>;

const IconComponent = () => (
  <svg viewBox="0 0 14 14">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-114.000000, -65.000000)" stroke="#0155FF">
        <g transform="translate(114.000000, 65.000000)">
          <circle cx="7" cy="7" r="6.5"></circle>
          <path
            d="M3.2986157,6.15254132 L10.2414876,6.15254132 C10.3622211,6.15254132 10.4710847,6.07983471 10.5173554,5.96823347 C10.563626,5.85663223 10.5379649,5.72813017 10.4526136,5.64278926 L8.89731405,4.08748967 C8.78066116,3.97083678 8.59169421,3.97083678 8.47505165,4.08748967 C8.35839876,4.20403926 8.35839876,4.39320248 8.47505165,4.50975207 L9.5206095,5.55530992 L3.2986157,5.55530992 C3.13375,5.55530992 3,5.68896694 3,5.85392562 C3,6.0188843 3.13375,6.15254132 3.2986157,6.15254132 Z M10.2414876,8.23042355 L3.2986157,8.23042355 C3.17785279,8.23042355 3.06898023,8.30316861 3.02274793,8.4147314 C2.97652624,8.52632308 3.00207864,8.65477009 3.08748967,8.74017562 L4.64278926,10.2954752 C4.7011157,10.3538017 4.77752066,10.3829649 4.85392562,10.3829649 C4.93033058,10.3829649 5.00673554,10.3538017 5.06506198,10.2954752 C5.18171488,10.1789256 5.18171488,9.9897624 5.06506198,9.87321281 L4.01950413,8.82765496 L10.2414979,8.82765496 C10.4063636,8.82765496 10.5401136,8.69399793 10.5401136,8.52903926 C10.5401136,8.36408058 10.4063533,8.23042355 10.2414876,8.23042355 L10.2414876,8.23042355 Z"
            strokeWidth="0.5"
            fill="#0155FF"
            fillRule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

const ExchangeIcon = (props: IconProps) => <Icon component={IconComponent} {...props} />;

export default ExchangeIcon;
